// extracted by mini-css-extract-plugin
export default {"version":"Version_version__ZIonJ"};